import { render, staticRenderFns } from "./whietlst-id.vue?vue&type=template&id=08d2831c"
import script from "./whietlst-id.vue?vue&type=script&lang=ts"
export * from "./whietlst-id.vue?vue&type=script&lang=ts"
import style0 from "./whietlst-id.vue?vue&type=style&index=0&id=08d2831c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports